import qs from "qs";
import http from "../http";

function getPriceInfo(priceId) {
  return http("GET", `${window.API_URL}/prices/${priceId}`);
}

function getPriceHistories(payload) {
  return http(
    "GET",
    `${window.API_URL}/price-histories?${qs.stringify(payload)}`
  );
}

function priceSetting(payload) {
  return http("POST", `${window.API_URL}/prices`, payload);
}

function getBasicContract(payload) {
  return http(
    "GET",
    `${window.API_URL}/my-basic-contract?${qs.stringify(payload)}`
  );
}

function basicContract(payload) {
  return http("POST", `${window.API_URL}/my-basic-contract`, payload);
}

function getContracts(payload) {
  return http(
    "GET",
    `${window.API_URL}/my-contracts/${payload.contractId}?exposeLevel=${payload.exposeLevel}`
  );
}

function getAbbreviatedContracts(payload) {
  return http(
    "GET",
    `${window.API_URL}/my-abbreviated-contracts?${qs.stringify(payload)}`
  );
}

function abbreviatedContract(payload) {
  return http("POST", `${window.API_URL}/my-abbreviated-contract`, payload);
}

function getTaskLatestPrices(payload) {
  return http(
    "GET",
    `${window.API_URL}/task-latest-prices?${qs.stringify(payload)}`
  );
}

function contractRetransmit(contractId) {
  return http(
    "POST",
    `${window.API_URL}/my-contracts/${contractId}/retransmit`
  );
}

function createPaymemts(payload) {
  return http("PUT", `${window.API_URL}/payments?${qs.stringify(payload)}`);
}

function getPriceGroups(payload) {
  return http("GET", `${window.API_URL}/price-groups?${qs.stringify(payload)}`);
}

function getPriceGroupDetail(priceGroupId) {
  return http("GET", `${window.API_URL}/price-groups/${priceGroupId}`);
}

function createPriceGroup(payload) {
  return http("POST", `${window.API_URL}/price-groups`, payload);
}

function deletePriceGroup(priceGroupId) {
  return http("DELETE", `${window.API_URL}/price-groups/${priceGroupId}`);
}

function updateTaskPriceGroup(taskId, payload) {
  return http("PUT", `${window.API_URL}/tasks/${taskId}/price-group`, payload);
}

export default {
  getPriceInfo,
  getPriceHistories,
  priceSetting,
  getBasicContract,
  basicContract,
  getContracts,
  getAbbreviatedContracts,
  abbreviatedContract,
  getTaskLatestPrices,
  contractRetransmit,
  createPaymemts,
  getPriceGroups,
  getPriceGroupDetail,
  createPriceGroup,
  deletePriceGroup,
  updateTaskPriceGroup,
};
